import { Link } from 'react-router-dom'
import { Avatar, Button, Dropdown, MenuProps, Space } from 'antd'
import { useAuth } from '../../contexts/Auth'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import { useLang } from '../../hooks/useLang'
import { useState } from 'react'
import {
  BookOutlined,
  CheckOutlined,
  LogoutOutlined,
  TranslationOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { handleLocaleSubmit } from '../../components/Locale'
import Gleap from 'gleap'

const RightHeader = () => {
  const { currentUser, logout } = useAuth()
  const { locales, selectedLocale, setLocale } = useLang()
  const [localeIsLoading, setLocaleIsLoading] = useState<boolean>(false)

  const items: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: (
        <Link to={'/settings/profile'}>
          {i18n.t(LocalizationKeys.Layout.RightHeader.Profile)}
        </Link>
      ),
    },

    {
      key: 'lang',
      icon: <TranslationOutlined />,
      label: i18n.t(LocalizationKeys.Layout.RightHeader.Lang),
      disabled: localeIsLoading,
      children: locales.map((locale) => ({
        key: locale.id,
        label: (
          <Space
            className="w-full"
            style={{ justifyContent: 'space-between', minWidth: 150 }}
          >
            {locale.label} {selectedLocale == locale.id && <CheckOutlined />}
          </Space>
        ),
        onClick: () => {
          handleLocaleSubmit(locale.id, setLocaleIsLoading, setLocale)
          Gleap.setLanguage(locale.id)
        },
      })),
    },
    {
      key: 'legal',
      icon: <BookOutlined />,
      label: (
        <Link to={'/legal'}>
          {i18n.t(LocalizationKeys.Layout.RightHeader.Legal)}
        </Link>
      ),
    },
    {
      key: 'logout',
      label: (
        <Button
          icon={<LogoutOutlined />}
          danger
          type="primary"
          size="small"
          className="w-full"
          onClick={() => logout()}
        >
          {i18n.t(LocalizationKeys.Layout.RightHeader.Logout)}
        </Button>
      ),
    },
  ]
  return (
    <Space size={12}>
      <Dropdown
        arrow
        menu={{ items }}
        placement="bottomRight"
        overlayStyle={{ width: 170, right: '10px' }}
      >
        <Avatar
          style={{
            marginBottom: 4,
            color: '#000',

            cursor: 'pointer',
          }}
          className="bg-pink"
        >
          {currentUser && currentUser.name
            ? currentUser!.name.slice(0, 1)
            : '--'}
        </Avatar>
      </Dropdown>
    </Space>
  )
}

export default RightHeader
